(function () {
  'use strict';

  /* ---- Sticky header + packages subnav offset ---- */
  function getBarHeightPx() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--site-header-bar-height').trim();
    var parsed = parseInt(raw, 10);
    return !isNaN(parsed) && parsed > 0 ? parsed : 90;
  }

  function syncPackagesSubnavHeight() {
    var subnav = document.querySelector('.packages-subnav--bar');
    if (!subnav) {
      document.documentElement.style.setProperty('--packages-subnav-height', '0px');
      document.body.classList.remove('has-packages-subnav');
      syncChromeHeight();
      return;
    }
    document.body.classList.add('has-packages-subnav');
    document.documentElement.style.setProperty('--packages-subnav-height', Math.round(subnav.getBoundingClientRect().height) + 'px');
    syncChromeHeight();
  }

  function syncChromeHeight() {
    var barHeight = getBarHeightPx();
    var subnav = document.querySelector('.packages-subnav--bar');
    var subnavHeight = subnav ? Math.round(subnav.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--site-chrome-height', (barHeight + subnavHeight) + 'px');
  }

  function syncChromeOffsets() {
    syncPackagesSubnavHeight();
  }

  syncChromeOffsets();
  window.addEventListener('resize', syncChromeOffsets, { passive: true });
  window.addEventListener('load', syncChromeOffsets);

  /* ---- Mobile Navigation ---- */
  var navToggle = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen);
      mobileNav.hidden = !isOpen;
      syncChromeOffsets();
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        mobileNav.hidden = true;
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });

    mobileNav.querySelectorAll('.mobile-nav__group-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group = toggle.closest('.mobile-nav__group');
        if (!group) return;
        var sub = group.querySelector('.mobile-nav__sub');
        var isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (sub) sub.hidden = !isOpen;
      });
    });
  }

  document.querySelectorAll('.nav-item--dropdown').forEach(function (item) {
    var trigger = item.querySelector('.nav-item__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      if (!window.matchMedia('(min-width: 901px)').matches) {
        event.preventDefault();
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      var open = item.classList.contains('is-open');
      document.querySelectorAll('.nav-item--dropdown.is-open').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.nav-item__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-open', !open);
      trigger.setAttribute('aria-expanded', !open ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.nav-item--dropdown')) return;
    document.querySelectorAll('.nav-item--dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---- Sticky Header ---- */
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- Sticky CTA ---- */
  var stickyCta = document.getElementById('stickyCta');
  var stickyAnchor = document.getElementById('hero')
    || document.getElementById('playlist-pricing')
    || document.getElementById('algorithmic-pricing')
    || document.getElementById('editorial-pricing')
    || document.getElementById('social-pricing')
    || document.getElementById('campaign-pricing')
    || document.querySelector('.campaign-landing__hero')
    || document.querySelector('#MainContent .section');

  if (stickyCta && stickyAnchor) {
    function setStickyVisible(visible) {
      stickyCta.classList.toggle('visible', visible);
      stickyCta.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sticky-cta-active', visible);
    }

    var ctaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setStickyVisible(!entry.isIntersecting);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 0px 0px' });

    ctaObserver.observe(stickyAnchor);
  }

  /* ---- Pricing Tabs ---- */
  var tabs = document.querySelectorAll('.pricing-tab');
  var panels = document.querySelectorAll('.pricing-panel');
  var pricingTabSummary = document.getElementById('pricingTabSummary');

  function updatePricingTabSummary(activeTab) {
    if (!pricingTabSummary || !activeTab) return;
    var summaryText = pricingTabSummary.querySelector('.pricing-tabs__summary-text');
    var desc = activeTab.getAttribute('data-desc') || '';
    if (summaryText) summaryText.textContent = desc;
  }

  function activatePricingTab(target, scrollToPanel) {
    if (!target) return;

    var activeTab = null;

    tabs.forEach(function (t) {
      var isActive = t.dataset.tab === target;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) activeTab = t;
    });

    updatePricingTabSummary(activeTab);

    panels.forEach(function (panel) {
      var isTarget = panel.id === 'panel-' + target;
      panel.classList.toggle('active', isTarget);
      panel.hidden = !isTarget;

      if (isTarget && target === 'algorithmic') {
        panel.querySelectorAll('.algo-playlist__art').forEach(function (img) {
          var src = img.getAttribute('src');
          if (src) img.setAttribute('src', src);
        });
      }

      if (isTarget && scrollToPanel) {
        var tabsWrap = document.querySelector('.pricing-tabs-wrap');
        var offset = tabsWrap ? tabsWrap.getBoundingClientRect().top + window.scrollY - 100 : 0;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activatePricingTab(tab.dataset.tab, window.innerWidth <= 768);
    });

    tab.addEventListener('keydown', function (e) {
      var index = Array.prototype.indexOf.call(tabs, tab);
      var next = null;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = tabs[index + 1] || tabs[0];
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = tabs[index - 1] || tabs[tabs.length - 1];
      }

      if (next) {
        e.preventDefault();
        next.focus();
        activatePricingTab(next.dataset.tab, false);
      }
    });
  });

  var pricingParams = new URLSearchParams(window.location.search);
  var pricingHash = (window.location.hash || '').replace('#', '');
  var initialTab = pricingParams.get('tab') || pricingHash;
  if (initialTab && document.getElementById('panel-' + initialTab)) {
    activatePricingTab(initialTab, false);
  } else if (tabs.length) {
    updatePricingTabSummary(document.querySelector('.pricing-tab.active') || tabs[0]);
  }

  /* ---- Scroll Reveal ---- */
  var revealEls = document.querySelectorAll('.reveal, .step-card, .price-card, .testimonial, .video-testimonial, .feature-card, .result-card, .faq-item, .case-study-shot');

  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el, i) {
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
      }
      el.style.transitionDelay = (i % 4) * 0.08 + 's';
      revealObserver.observe(el);
    });
  }

  /* ---- Animated Counters ---- */
  var counters = document.querySelectorAll('.counter');

  if (counters.length) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    var suffix = el.dataset.suffix || '';
    var duration = 2200;
    var start = performance.now();

    function update(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 4);
      var current = Math.floor(eased * target);

      if (target >= 50 && suffix === 'M') {
        el.textContent = current + 'M+';
      } else {
        el.textContent = current.toLocaleString() + suffix;
      }

      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  /* ---- Smooth Scroll ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = anchor.getAttribute('href');
      if (id === '#') return;

      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        var offset = 100;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ---- Mini Cart Drawer ---- */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartTrigger = document.getElementById('cartTrigger');
  var cartCount = document.getElementById('cartCount');
  var cartBody = document.getElementById('cartDrawerBody');
  var cartFooter = document.getElementById('cartDrawerFooter');
  var cartSubtotal = document.getElementById('cartDrawerSubtotal');
  var cartDiscountRow = document.getElementById('cartDrawerDiscount');
  var cartDiscountAmount = document.getElementById('cartDrawerDiscountAmount');
  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateCartCount(count) {
    if (!cartCount || !cartTrigger) return;
    cartCount.textContent = count;
    cartCount.hidden = count < 1;
    cartTrigger.setAttribute('aria-label', 'Open cart (' + count + ' items)');
  }

  function getVisibleCartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    if (!window.MSCartPricing) return cart.items;
    return cart.items.filter(function (item) {
      return !window.MSCartPricing.isCheckoutAdjustmentLine(item);
    });
  }

  function findLinkedAdjustmentItem(cart, campaignItem) {
    if (window.MSCartPricing) {
      return window.MSCartPricing.findLinkedAdjustmentItem(cart, campaignItem);
    }
    return null;
  }

  function renderCartItem(item, line) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</span>'
      : '';
    var image = item.image
      ? '<img class="cart-drawer__item-image" src="' + item.image + '" alt="" width="64" height="64" loading="lazy">'
      : '<div class="cart-drawer__item-image cart-drawer__item-image--placeholder"><i class="ti ti-music" aria-hidden="true"></i></div>';
    var minusDisabled = item.quantity <= 1 ? ' disabled aria-disabled="true"' : '';
    var lineKey = item.key ? escapeHtml(item.key) : '';

    return (
      '<li class="cart-drawer__item" data-line="' + line + '" data-key="' + lineKey + '">' +
        image +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-key="' + lineKey + '" data-cart-qty="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity"' + minusDisabled + '>−</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-key="' + lineKey + '" data-cart-qty="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-drawer__item-price">' +
              (window.MSCartPricing
                ? window.MSCartPricing.formatItemPriceHtml(item, formatMoney)
                : formatMoney(item.final_line_price)) +
            '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__remove" data-cart-key="' + lineKey + '" data-cart-remove="' + line + '" aria-label="Remove item">' +
          '<i class="ti ti-trash" aria-hidden="true"></i>' +
        '</button>' +
      '</li>'
    );
  }

  function renderCartSubtotal(cart) {
    if (!cartSubtotal) return;
    if (!cart || cart.item_count === 0) {
      cartSubtotal.textContent = formatMoney(0);
      if (cartDiscountRow) cartDiscountRow.hidden = true;
      return;
    }
    if (window.MSCartPricing) {
      cartSubtotal.innerHTML = window.MSCartPricing.formatSubtotalHtml(cart, formatMoney);
      var discountCents = window.MSCartPricing.getCartDiscountCents(cart);
      if (cartDiscountRow && cartDiscountAmount) {
        if (discountCents > 0) {
          cartDiscountRow.hidden = false;
          cartDiscountAmount.textContent = '-' + formatMoney(discountCents);
        } else {
          cartDiscountRow.hidden = true;
          cartDiscountAmount.textContent = '';
        }
      }
      return;
    }
    cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartDiscountRow) cartDiscountRow.hidden = true;
  }

  function renderCart(cart) {
    if (!cartBody || !cart || !Array.isArray(cart.items)) return;

    var visibleItems = getVisibleCartItems(cart);
    updateCartCount(window.MSCartPricing
      ? window.MSCartPricing.getVisibleItemCount(cart)
      : visibleItems.length);

    if (visibleItems.length === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<span class="cart-drawer__empty-icon"><i class="ti ti-shopping-cart" aria-hidden="true"></i></span>' +
          '<p>Your cart is empty</p>' +
          '<a href="#pricing" class="btn btn--primary btn--sm" data-cart-close>Browse packages</a>' +
        '</div>';
      if (cartFooter) cartFooter.hidden = true;
      renderCartSubtotal(cart);
      return;
    }

    var itemsHtml = visibleItems.map(function (item) {
      var line = cart.items.indexOf(item) + 1;
      return renderCartItem(item, line);
    }).join('');

    cartBody.innerHTML = '<ul class="cart-drawer__items" id="cartDrawerItems">' + itemsHtml + '</ul>';
    if (cartFooter) cartFooter.hidden = false;
    renderCartSubtotal(cart);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLineItem(key, line, quantity) {
    if (quantity < 0) return Promise.resolve(null);

    var payload = key ? { id: key, quantity: quantity } : { line: line, quantity: quantity };

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        var sync = window.MSCartPricing
          ? window.MSCartPricing.syncBundleAdjustments(cart)
          : Promise.resolve(cart);
        return sync;
      })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('theme:cart-updated', {
          detail: { cart: cart, source: 'drawer' }
        }));
        return cart;
      })
      .catch(function () {
        return fetchCart();
      });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    fetchCart();
  }

  document.addEventListener('theme:open-cart', openCart);

  function syncHeaderCartCount() {
    if (!cartCount) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(window.MSCartPricing
          ? window.MSCartPricing.getVisibleItemCount(cart)
          : cart.item_count);
      })
      .catch(function () {});
  }

  if (cartCount) syncHeaderCartCount();

  document.addEventListener('theme:cart-updated', function (e) {
    if (!e.detail || !e.detail.cart || e.detail.source === 'drawer') return;
    renderCart(e.detail.cart);
  });

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', openCart);
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCart);
    });

    cartDrawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        if (qtyBtn.disabled) return;
        qtyBtn.disabled = true;
        changeLineItem(
          qtyBtn.dataset.cartKey || '',
          parseInt(qtyBtn.dataset.cartQty, 10),
          parseInt(qtyBtn.dataset.qty, 10)
        ).finally(function () {
          qtyBtn.disabled = false;
        });
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var line = parseInt(removeBtn.dataset.cartRemove, 10);
            var item = cart.items[line - 1];
            var linked = item ? findLinkedAdjustmentItem(cart, item) : null;
            return changeLineItem(
              removeBtn.dataset.cartKey || '',
              line,
              0
            ).then(function (updatedCart) {
              if (!linked) return updatedCart;
              return changeLineItem(linked.key, cart.items.indexOf(linked) + 1, 0);
            });
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
        closeCart();
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    e.preventDefault();
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return fetchCart();
      })
      .then(function () { openCart(); })
      .catch(function () { form.submit(); });
  });

  /* ---- Product quantity ---- */
  function getProductQuantity() {
    var qtyInput = document.querySelector('[data-product-quantity]');
    if (!qtyInput) return 1;
    return Math.max(1, parseInt(qtyInput.value, 10) || 1);
  }

  document.querySelectorAll('.product-quantity').forEach(function (wrap) {
    var input = wrap.querySelector('[data-product-quantity]');
    if (!input) return;

    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, getProductQuantity() - 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = Math.min(99, getProductQuantity() + 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    input.addEventListener('change', function () {
      input.value = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  /* ---- Campaign Product Configurator ---- */
  var campaignForm = document.getElementById('campaignForm');
  if (campaignForm) {
    var campaignType = document.getElementById('CampaignType');
    var totalDisplay = document.getElementById('campaignTotalDisplay');
    var totalProperty = document.getElementById('CampaignTotalProperty');
    var basePrice = parseInt(campaignForm.dataset.basePrice, 10) || 0;
    var moneyFormat = window.themeMoneyFormat || '${{amount}}';

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedType() {
      if (!campaignType || !campaignType.selectedOptions.length) return '';
      return campaignType.selectedOptions[0].dataset.type || '';
    }

    function toggleCampaignGroups() {
      var type = getSelectedType();
      campaignForm.querySelectorAll('[data-campaign-group]').forEach(function (group) {
        var groups = (group.dataset.campaignGroup || '').split(/\s+/);
        var show = type && groups.indexOf(type) !== -1;
        group.hidden = !show;
        group.querySelectorAll('input, select, textarea').forEach(function (field) {
          field.disabled = !show;
          if (!show && field.tagName === 'SELECT') field.selectedIndex = 0;
          if (!show && (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA')) field.value = '';
        });
      });
    }

    function getMetaPrice() {
      var budgetEl = document.getElementById('CampaignBudget');
      var durationEl = document.getElementById('CampaignDuration');
      if (!budgetEl || !durationEl) return 0;
      var daily = parseInt(budgetEl.selectedOptions[0].dataset.price, 10) || 0;
      var days = parseInt(durationEl.selectedOptions[0].dataset.days, 10) || 0;
      return daily * days * 100;
    }

    function updateCampaignPricing() {
      var type = getSelectedType();
      var total = 0;

      campaignForm.querySelectorAll('[data-subtotal-for]').forEach(function (sub) {
        sub.textContent = formatMoney(0);
      });

      if (type === 'meta') {
        total = getMetaPrice();
        var budgetSub = campaignForm.querySelector('[data-subtotal-for="CampaignBudget"]');
        if (budgetSub) budgetSub.textContent = formatMoney(total);
      }

      campaignForm.querySelectorAll('[data-price-field]').forEach(function (field) {
        if (field.disabled) return;
        var group = field.closest('[data-campaign-group]');
        if (!group || group.hidden) return;
        var price = parseInt(field.selectedOptions[0].dataset.price, 10) || 0;
        if (type !== 'meta' && price > 0) total = price;
        var sub = campaignForm.querySelector('[data-subtotal-for="' + field.id + '"]');
        if (sub) sub.textContent = formatMoney(price);
      });

      if (!total) total = basePrice;

      total *= getProductQuantity();

      if (totalDisplay) totalDisplay.textContent = formatMoney(total);
      if (totalProperty) totalProperty.value = formatMoney(total);
    }

    function onCampaignChange() {
      toggleCampaignGroups();
      updateCampaignPricing();
    }

    var campaignTypeFromUrl = {
      editorial: 'Spotify - Editorial Streams',
      algorithmic: 'Algorithmic & Chart Ranking',
      radio: 'Spotify - Radio',
      meta: 'Facebook/Instagram Ads',
      'algo-playlist': 'Algorithmic Playlist',
      playlist: 'User Playlist'
    };
    var urlType = new URLSearchParams(window.location.search).get('type');
    if (urlType && campaignTypeFromUrl[urlType]) {
      var matchPrefix = campaignTypeFromUrl[urlType];
      Array.prototype.some.call(campaignType.options, function (opt) {
        if (opt.value.indexOf(matchPrefix) === 0) {
          campaignType.value = opt.value;
          return true;
        }
        return false;
      });
    }

    campaignForm.addEventListener('change', onCampaignChange);
    campaignForm.addEventListener('input', updateCampaignPricing);
    onCampaignChange();

    var campaignProductForm = document.getElementById('productCampaignForm');
    if (campaignProductForm) {
      campaignProductForm.addEventListener('input', updateCampaignPricing);
    }
  }

  /* ---- Playlist Product Form ---- */
  var playlistForm = document.getElementById('playlistForm');
  if (playlistForm) {
    var bookingType = document.getElementById('BookingType');
    var durationField = document.getElementById('Duration');
    var playlistTotalDisplay = document.getElementById('playlistTotalDisplay');
    var playlistTotalProperty = document.getElementById('PlaylistTotalProperty');
    var playlistDurationSubtotal = document.getElementById('playlistDurationSubtotal');
    var playlistBasePrice = parseInt(playlistForm.dataset.basePrice, 10) || 0;
    var playlistMoneyFormat = window.themeMoneyFormat || '${{amount}}';

    function formatPlaylistMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, playlistMoneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function togglePreorderField() {
      var isPreorder = bookingType && bookingType.value === 'Pre-Order';
      playlistForm.querySelectorAll('[data-playlist-group="preorder"]').forEach(function (group) {
        group.hidden = !isPreorder;
        var field = group.querySelector('[data-input], input:not([data-toggle]), select, textarea');
        var wrap = group.querySelector('.date-picker-wrap');
        if (field) {
          field.disabled = !isPreorder;
          field.required = isPreorder;
        }
        if (!isPreorder && window.MSDatePicker) {
          window.MSDatePicker.clearWrap(wrap);
        }
      });
    }

    function updatePlaylistPricing() {
      var total = playlistBasePrice;
      var variantIdInput = document.getElementById('productVariantId');
      var basePriceEl = document.getElementById('productBasePrice');

      if (durationField && durationField.selectedOptions.length) {
        var selected = durationField.selectedOptions[0];
        var durationPrice = parseInt(selected.dataset.price, 10) || 0;
        if (durationPrice > 0) total = durationPrice;
        if (variantIdInput && selected.dataset.variantId) {
          variantIdInput.value = selected.dataset.variantId;
        }
      }

      var unitTotal = total;
      total *= getProductQuantity();
      if (playlistDurationSubtotal) playlistDurationSubtotal.textContent = formatPlaylistMoney(unitTotal);
      if (playlistTotalDisplay) playlistTotalDisplay.textContent = formatPlaylistMoney(total);
      if (playlistTotalProperty) playlistTotalProperty.value = formatPlaylistMoney(total);
      if (basePriceEl) basePriceEl.textContent = formatPlaylistMoney(unitTotal);
    }

    function onPlaylistChange() {
      togglePreorderField();
      updatePlaylistPricing();
    }

    playlistForm.addEventListener('change', onPlaylistChange);
    playlistForm.addEventListener('input', updatePlaylistPricing);
    onPlaylistChange();

    var playlistProductForm = document.getElementById('productPlaylistForm');
    if (playlistProductForm) {
      playlistProductForm.addEventListener('input', updatePlaylistPricing);
    }
  }

  /* ---- Case study lightbox ---- */
  var caseLightbox = document.getElementById('caseStudyLightbox');
  if (caseLightbox) {
    var caseTriggers = Array.prototype.slice.call(document.querySelectorAll('[data-case-zoom]'));
    if (caseTriggers.length) {
      var caseImg = caseLightbox.querySelector('.case-study-lightbox__img');
      var caseCaption = caseLightbox.querySelector('.case-study-lightbox__caption');
      var caseStage = caseLightbox.querySelector('.case-study-lightbox__stage');
      var lastFocus = null;
      var activeIndex = 0;
      var zoomLevel = 1;
      var zoomLevels = [0.75, 1, 1.5, 2, 2.5];

      function setCaseZoom(level) {
        zoomLevel = level;
        if (caseImg) caseImg.style.transform = 'scale(' + zoomLevel + ')';
        var resetBtn = caseLightbox.querySelector('[data-case-zoom-reset]');
        if (resetBtn) resetBtn.textContent = Math.round(zoomLevel * 100) + '%';
      }

      function openCaseLightbox(index) {
        activeIndex = index;
        var trigger = caseTriggers[activeIndex];
        if (!trigger || !caseImg) return;

        lastFocus = document.activeElement;
        caseImg.src = trigger.getAttribute('data-full-src') || '';
        var thumb = trigger.querySelector('img');
        caseImg.alt = thumb ? thumb.alt : '';
        if (caseCaption) caseCaption.textContent = trigger.getAttribute('data-caption') || '';
        setCaseZoom(1);
        if (caseStage) {
          caseStage.scrollTop = 0;
          caseStage.scrollLeft = 0;
        }

        caseLightbox.hidden = false;
        caseLightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('case-lightbox-open');
        var closeBtn = caseLightbox.querySelector('.case-study-lightbox__close');
        if (closeBtn) closeBtn.focus();
      }

      function closeCaseLightbox() {
        caseLightbox.hidden = true;
        caseLightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('case-lightbox-open');
        if (caseImg) caseImg.src = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function showAdjacentCase(delta) {
        var next = activeIndex + delta;
        if (next < 0) next = caseTriggers.length - 1;
        if (next >= caseTriggers.length) next = 0;
        openCaseLightbox(next);
      }

      function stepCaseZoom(delta) {
        var idx = zoomLevels.indexOf(zoomLevel);
        if (idx === -1) idx = zoomLevels.indexOf(1);
        idx = Math.max(0, Math.min(zoomLevels.length - 1, idx + delta));
        setCaseZoom(zoomLevels[idx]);
      }

      caseTriggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
          openCaseLightbox(index);
        });
      });

      caseLightbox.querySelectorAll('[data-case-close]').forEach(function (el) {
        el.addEventListener('click', closeCaseLightbox);
      });

      var casePrevBtn = caseLightbox.querySelector('[data-case-prev]');
      var caseNextBtn = caseLightbox.querySelector('[data-case-next]');
      if (casePrevBtn) casePrevBtn.addEventListener('click', function () { showAdjacentCase(-1); });
      if (caseNextBtn) caseNextBtn.addEventListener('click', function () { showAdjacentCase(1); });

      var caseZoomInBtn = caseLightbox.querySelector('[data-case-zoom-in]');
      var caseZoomOutBtn = caseLightbox.querySelector('[data-case-zoom-out]');
      var caseZoomResetBtn = caseLightbox.querySelector('[data-case-zoom-reset]');
      if (caseZoomInBtn) caseZoomInBtn.addEventListener('click', function () { stepCaseZoom(1); });
      if (caseZoomOutBtn) caseZoomOutBtn.addEventListener('click', function () { stepCaseZoom(-1); });
      if (caseZoomResetBtn) caseZoomResetBtn.addEventListener('click', function () { setCaseZoom(1); });

      document.addEventListener('keydown', function (e) {
        if (caseLightbox.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeCaseLightbox();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showAdjacentCase(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showAdjacentCase(1);
        } else if (e.key === '+' || e.key === '=') {
          e.preventDefault();
          stepCaseZoom(1);
        } else if (e.key === '-') {
          e.preventDefault();
          stepCaseZoom(-1);
        }
      });
    }
  }

  /* ---- Video testimonials ---- */
  function parseVideoTestimonialUrl(url) {
    if (!url) return null;
    var ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if (ytMatch) return { type: 'youtube', id: ytMatch[1] };
    var vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) return { type: 'vimeo', id: vimeoMatch[1] };
    if (/\.(mp4|webm)(\?|$)/i.test(url)) return { type: 'file', src: url };
    return null;
  }

  function prefersReducedVideoLoading() {
    if (window.matchMedia('(prefers-reduced-data: reduce)').matches) return true;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return false;
    return !!(conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g');
  }

  var videoTestimonialCards = document.querySelectorAll('.video-testimonial');
  if (videoTestimonialCards.length) {
    var posterPrimeQueue = [];
    var posterPrimeActive = false;

    function drainPosterPrimeQueue() {
      if (posterPrimeActive || !posterPrimeQueue.length) return;
      posterPrimeActive = true;
      primeVideoTestimonialPoster(posterPrimeQueue.shift());
    }

    function primeVideoTestimonialPoster(video) {
      if (!video || video.dataset.posterReady === 'true') {
        posterPrimeActive = false;
        drainPosterPrimeQueue();
        return;
      }

      var settled = false;

      function finishPosterPrime() {
        posterPrimeActive = false;
        drainPosterPrimeQueue();
      }

      function markReady() {
        if (settled) return;
        settled = true;
        video.dataset.posterReady = 'true';
        video.classList.add('video-testimonial__poster--ready');
        video.pause();
        finishPosterPrime();
      }

      function markFallback() {
        if (settled) return;
        settled = true;
        video.classList.add('video-testimonial__poster--fallback');
        finishPosterPrime();
      }

      function ensureVideoSrc() {
        if (video.getAttribute('src')) return true;
        var lazySrc = video.getAttribute('data-src');
        if (!lazySrc) return false;
        video.setAttribute('src', lazySrc);
        return true;
      }

      function seekToPreview() {
        var target = 0.25;
        if (video.duration && isFinite(video.duration)) {
          target = Math.min(0.5, Math.max(0.1, video.duration * 0.05));
        }
        if (Math.abs(video.currentTime - target) < 0.05) {
          markReady();
          return;
        }
        video.addEventListener('seeked', function onSeeked() {
          video.removeEventListener('seeked', onSeeked);
          markReady();
        }, { once: true });
        try {
          video.currentTime = target;
        } catch (err) {
          markReady();
        }
      }

      function prime() {
        if (video.readyState >= 2) {
          seekToPreview();
        } else {
          video.addEventListener('loadeddata', seekToPreview, { once: true });
          video.addEventListener('canplay', seekToPreview, { once: true });
        }
      }

      if (!ensureVideoSrc()) {
        markFallback();
        return;
      }

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      video.addEventListener('error', markFallback, { once: true });
      setTimeout(function () {
        if (settled) return;
        if (video.readyState >= 1) markReady();
        else markFallback();
      }, 5000);

      if (video.readyState >= 1) {
        prime();
      } else {
        video.addEventListener('loadedmetadata', prime, { once: true });
      }

      try {
        video.load();
      } catch (loadErr) {
        markFallback();
      }
    }

    function queuePosterPrime(video) {
      if (!video || video.dataset.posterReady === 'true') return;
      posterPrimeQueue.push(video);
      drainPosterPrimeQueue();
    }

    function prepareLazyVideoPosters() {
      var posterVideos = document.querySelectorAll('.video-testimonial__poster-video');
      if (!posterVideos.length) return;

      posterVideos.forEach(function (video) {
        if (video.getAttribute('src') && !video.getAttribute('data-src')) {
          video.setAttribute('data-src', video.getAttribute('src'));
          video.removeAttribute('src');
        }
      });

      if (prefersReducedVideoLoading()) {
        posterVideos.forEach(function (video) {
          video.classList.add('video-testimonial__poster--fallback');
        });
        return;
      }

      if (!('IntersectionObserver' in window)) {
        posterVideos.forEach(queuePosterPrime);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          queuePosterPrime(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '120px 0px',
        threshold: 0.01
      });

      posterVideos.forEach(function (video) {
        observer.observe(video);
      });
    }

    prepareLazyVideoPosters();

    function stopVideoTestimonial(card) {
      var player = card.querySelector('.video-testimonial__player');
      if (!player) return;
      player.innerHTML = '';
      player.hidden = true;
      card.classList.remove('is-playing');
    }

    function buildVideoTestimonialPlayer(trigger) {
      var mp4 = trigger.getAttribute('data-mp4');
      if (mp4) {
        var video = document.createElement('video');
        video.src = mp4;
        video.controls = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        return video;
      }

      var parsed = parseVideoTestimonialUrl(trigger.getAttribute('data-video-url') || '');
      if (!parsed) return null;

      if (parsed.type === 'file') {
        var fileVideo = document.createElement('video');
        fileVideo.src = parsed.src;
        fileVideo.controls = true;
        fileVideo.playsInline = true;
        fileVideo.setAttribute('playsinline', '');
        return fileVideo;
      }

      var iframe = document.createElement('iframe');
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.title = trigger.getAttribute('aria-label') || 'Video testimonial';

      if (parsed.type === 'youtube') {
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + parsed.id + '?autoplay=1&rel=0';
      } else if (parsed.type === 'vimeo') {
        iframe.src = 'https://player.vimeo.com/video/' + parsed.id + '?autoplay=1';
      }

      return iframe;
    }

    videoTestimonialCards.forEach(function (card) {
      var trigger = card.querySelector('[data-video-testimonial]');
      if (!trigger || trigger.disabled) return;

      trigger.addEventListener('click', function () {
        var player = card.querySelector('.video-testimonial__player');
        if (!player) return;

        videoTestimonialCards.forEach(function (otherCard) {
          if (otherCard !== card) stopVideoTestimonial(otherCard);
        });

        var media = buildVideoTestimonialPlayer(trigger);
        if (!media) return;

        player.innerHTML = '';
        player.appendChild(media);
        player.hidden = false;
        card.classList.add('is-playing');

        if (media.tagName === 'VIDEO') {
          media.play().catch(function () {});
        }
      });
    });
  }
})();
